import * as React from "react";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { AppUtils } from "source/framework/appUtils";
import { Translations } from "ui/Scripts/source/models/translations";
import { Grid } from "@mui/material";
import { FilterSearchField } from "source/components/framework/Filters/FilterSearchField";
import { SaveDataObj } from "source/framework/saveData";
import { Base } from "ui/Scripts/source/framework/base";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { TreeCheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown";
import { FilterButtons } from "source/components/framework/Filters/FilterButtons";
import { DrawerContent } from "source/components/framework/Drawer/DrawerContent";
import { PageFilterConditionDrawer } from "source/components/framework/Page/PageFilterConditionDrawer";
import { AppReportStateIdFilterActive, IAppReportPageFilterLists, IAppReportPageFilterState } from "./AppReportPageUtils";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";

export interface IAppReportPageFilterDrawerProp extends IAppReportPageFilterLists, IAppReportPageFilterState {
    open: boolean;
    filter: IListFilterItem;
    canRemoveSharedFilters: boolean;
    stateIsReadOnly?: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, filterState: IAppReportPageFilterState) => any;
    onCancel: () => void;
}

export interface IAppReportPageFilterDrawerState extends IAppReportPageFilterState {
}

export class AppReportPageFilterDrawer extends React.Component<IAppReportPageFilterDrawerProp, IAppReportPageFilterDrawerState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: IAppReportPageFilterDrawerProp): IAppReportPageFilterDrawerState => {
        return {
            ...props,
        };
    };

    constructor(props: IAppReportPageFilterDrawerProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: IAppReportPageFilterDrawerProp, prevState: IAppReportPageFilterDrawerState): void {
        const props = this.props;
        if (!prevProps ||
            (prevProps.filter?.getHash() === props.filter?.getHash() &&
            Base.equalStrArrays(prevProps.selectedUnitIds, props.selectedUnitIds) &&
            Base.equalStrArrays(prevProps.selectedStateIds, props.selectedStateIds)
            )) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChangeUnitIds = (selectedUnitIds: string[]) => {
        this.setState({
            selectedUnitIds
        });
    };

    handleChangeStateIds = (selectedStateIds: string[]) => {
        this.setState({
            selectedStateIds
        });
    };

    getSaveDataFromState = (_props: IAppReportPageFilterDrawerProp, state: IAppReportPageFilterDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("selectedUnitIds", state.selectedUnitIds);
        result.append("selectedStateIds", state.selectedStateIds);
        return result;
    };

    static filterIsSet = (filterLists: IAppReportPageFilterLists, filterState: IAppReportPageFilterState): boolean => {
        return !(
            Base.equalStrArrays(filterState.selectedUnitIds, [filterLists.units[0].id]) &&
            Base.equalStrArrays(filterState.selectedStateIds, [filterLists.states[0].id])
        );
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        if (!saveAs) {
            props.onOk(false, state);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, state);
            });
        }
    };

    static getClearedParametersState = (props: IAppReportPageFilterLists) => {
        return {
            selectedUnitIds: [props.units[0].id],
            selectedStateIds: [props.states[0].id],
        };
    };

    handleClear = () => {
        this.setState(
            AppReportPageFilterDrawer.getClearedParametersState(this.props)
        );
    };

    handleSave = async () => {
        this.props.onOk(true, this.state);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageFilterConditionDrawer
                open={props.open}
                onClose={() => this.handleCancel(false)}
            >
                <DrawerContent
                    content={
                        <>
                            {!!props.onSaveFilter && !!props.onRemoveFilter &&
                                <FilterSearchField
                                    filter={props.filter}
                                    canRemoveSharedFilters={props.canRemoveSharedFilters}
                                    onSaveFilter={props.onSaveFilter ? this.handleSaveFilter : null}
                                    onRemoveFilter={props.onRemoveFilter}
                                />
                            }
                            <GridRow>
                                <Grid item sm={6}>
                                    <FormField title={Translations.State}>
                                        <CheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedStateIds}
                                            toggleAll={true}
                                            toggleAllId={Base.emptyGuid}
                                            toggleSingleSelectIds={[AppReportStateIdFilterActive]}
                                            values={props.states}
                                            onChange={this.handleChangeStateIds}
                                        />
                                    </FormField>
                                </Grid>
                                <Grid item sm={6}>
                                    <FormField title={Translations.Unit}>
                                        <TreeCheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedUnitIds}
                                            values={props.units}
                                            onChange={this.handleChangeUnitIds} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </>
                    }
                    actions={
                        <FilterButtons
                            onSave={this.handleSave}
                            onCancel={this.handleCancel}
                            onClear={this.handleClear}
                        />
                    }
                />
            </PageFilterConditionDrawer>
        );
    }
}
